<div class="print-history-popup">
  <div class="print-history-popup-body">
    <button class="t-btn-popup-close" aria-label="close popup" (click)="close()"></button>
    <h2 class="popup-title">{{ 'GUI.SendQuestionnaire.Title' | translate }}</h2>

    <div class="send-questionnaire-status" *ngIf="loading">{{ 'GUI.SendQuestionnaire.Loading' | translate }}</div>
    <div class="send-questionnaire-status -error" *ngIf="loadError">{{ 'GUI.SendQuestionnaire.Load error' | translate }}</div>

    <ng-container *ngIf="!loading && !loadError && !sent">
      <label class="send-questionnaire-field">
        <span>{{ 'GUI.SendQuestionnaire.Phone' | translate }}</span>
        <input type="tel" dir="ltr" [(ngModel)]="phone" class="search-patient-field" />
      </label>
      <label class="send-questionnaire-field">
        <span>{{ 'GUI.SendQuestionnaire.Questionnaire' | translate }}</span>
        <select [(ngModel)]="selectedId" class="t-select">
          <option [ngValue]="null">{{ 'GUI.SendQuestionnaire.Choose' | translate }}</option>
          <option *ngFor="let q of questionnaires" [ngValue]="q.AutoIndex">{{ q.name }}</option>
        </select>
      </label>

      <div class="send-questionnaire-status -error" *ngIf="error">
        {{ errorDetail || ('GUI.SendQuestionnaire.Send error' | translate) }}
      </div>

      <div class="send-questionnaire-actions">
        <button class="t-btn-grad" (click)="send()" [disabled]="sending || !selectedId || !phone">
          {{ (sending ? 'GUI.SendQuestionnaire.Sending' : 'GUI.SendQuestionnaire.Send') | translate }}
        </button>
        <button class="btn-cancel" (click)="close()">{{ 'GUI.SendQuestionnaire.Cancel' | translate }}</button>
      </div>
    </ng-container>

    <div class="send-questionnaire-sent" *ngIf="sent">
      <p>{{ 'GUI.SendQuestionnaire.Sent' | translate }}</p>
      <button class="t-btn-grad" (click)="close()">{{ 'GUI.SendQuestionnaire.Close' | translate }}</button>
    </div>
  </div>
</div>
